import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { CSSTransition } from 'react-transition-group';
import { last, split } from 'lodash';
import { getFileSize } from '../../utils/format';
import DropZonePlaceholder from './DropZonePlaceholder';
import styles from './DropZone.module.scss';

const formatFileObjects = (inputFiles) => {
  return inputFiles.map((file) => {
    const { size, units } = getFileSize(file.size);

    // TODO: need to clarify comments below from the BE side
    return {
      name: file.name, // Deprecated use fileName instead
      fileName: file.name,
      fileLink: null,
      size: file.size,
      sizeToDisplay: `${size}${units}`,
      fileObject: file,
      serverFileName: null, // Deprecated use fileLink instead,
      type: last(split(file.type, '/')),
      status: 'loading',
    };
  });
};

const onClick = (e) => e.stopPropagation();

const DropZone = ({
  accept,
  maxFileSizeMb,
  onDrop,
  children,
  openDialogOnClick,
  disabled,
  className,
}) => {
  const onFilesDrop = (acceptedFiles, rejectedFiles) => {
    onDrop(formatFileObjects(acceptedFiles), rejectedFiles);
  };

  const { rootRef, inputRef, getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: useCallback(onFilesDrop, [onDrop]),
    disabled,
    accept,
    maxSize: maxFileSizeMb * 1024 * 1024,
  });

  const rootProps = {};

  if (!openDialogOnClick) {
    rootProps.onClick = onClick;
  }

  return (
    <div {...getRootProps(rootProps)} className={`${styles.dropZone} ${className}`}>
      <input {...getInputProps()} />
      <CSSTransition in={isDragActive} timeout={200} classNames={styles.animation} unmountOnExit>
        <DropZonePlaceholder />
      </CSSTransition>
      {children({ inputRef, rootRef })}
    </div>
  );
};

DropZone.propTypes = {
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  maxFileSizeMb: PropTypes.number,
  onDrop: PropTypes.func.isRequired,
  openDialogOnClick: PropTypes.bool,
};

DropZone.defaultProps = {
  accept: '',
  maxFileSizeMb: 2,
  openDialogOnClick: true,
};

export default DropZone;
